import { render, staticRenderFns } from "./lgnInput.vue?vue&type=template&id=a54b5108&"
import script from "./lgnInput.vue?vue&type=script&lang=js&"
export * from "./lgnInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports